import { Grid } from "@mui/material";
import { useEffect, useReducer } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert"
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer"
import CompanyControlService from "./CompanyControlService"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { ImageUploadCard } from "../../componentes/DragNDrop/ImageUploadCard";
import DefaultChip from "../../componentes/chip/DefaultChip";
import { Typography } from "@material-ui/core";
/**
 * Author : AndréK
 * 26/08/2022
*/
const columnsCompany = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "companyName",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="companyName" name="company" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.companyName}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "socialReason",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="socialReason" name="company" />;
        },
        flex: 1
    },
    {
        field: "cnpj",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="cnpj" name="cnpj" />;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    {props.cnpj ?
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.cnpj}
                            </Typography>}
                        />
                        : null}
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const CompanyRegister = ({ updateId }) => {

    // CBernardo - 17/06/2026 - Função antiga de CNPJ
    // function formatCNPJ(value) {
    //     value = value.replace(/\D/g, '');

    //     value = value.replace(/^(\d{2})(\d)/, '$1.$2');
    //     value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    //     value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
    //     value = value.replace(/(\d{4})(\d)/, '$1-$2');

    //     return value.slice(0, 18); // Limita ao tamanho máximo do CNPJ
    // }
    // Fim - CBernardo - 17/06/2026 - Função antiga de CNPJ


    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        companyName: "",
        socialReason: "",
        cnpj: "",
        CompanyRows: [],
        img: "",
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [CompanyControl, dispatch] = useReducer(reducer, initialState);

    const { id, companyName, socialReason, cnpj, status, img } = CompanyControl
    const { success, error, CompanyRows, ...data } = CompanyControl

    useEffect(() => {
        updateId({ id: id })
    }, [id])

    const handleChange = ({ target: { name, value } }) => {
        // CBernardo - 17/06/2026 - Função antiga de CNPJ
        // if (name === 'cnpj') {
        //     const formatted = formatCNPJ(value);
        //     dispatch({ type: 'update', data: { [name]: value, cnpj: formatted } })
        // }
        // else {
        //     dispatch({ type: 'update', data: { [name]: value } })
        // }
        // Fim - CBernardo - 17/06/2026 - Função antiga de CNPJ

        dispatch({ type: 'update', data: { [name]: value } })
    }

    const handleSearch = () => {
        CompanyControlService
            .getCompany(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { CompanyRows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { CompanyRows: [] } }));
    }
    const canSave = () => companyName !== "" && cnpj !== "" && status !== 2;

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                CompanyControlService
                    .updateCompany(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                CompanyControlService
                    .createCompany(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id, message: t("noDataExport") } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }

    }

    const handleCellClickCompany = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                companyName: data.companyName,
                socialReason: data.socialReason,
                cnpj: data.cnpj,
                status: data.status,
                img: data.img,
            }
        })
    }

    const handleReloadImg = () => {
        CompanyControlService
            .getCompany(data)
            .then((response) => {
                if (response.status === 200) {
                    const rows = []
                    response.data.forEach(item => {
                        rows.push({
                            id: item.id,
                            companyName: item.companyName,
                            socialReason: item.socialReason,
                            cnpj: item.cnpj,
                            img: item.img,
                            status: item.status
                        });
                    });
                    dispatch({ type: 'update', data: { ...rows[0], CompanyRows: rows } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { CompanyRows: [] } }));
    }

    useEffect(() => {
        handleSearch();
    }, [])

    // CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico
    const handleChangeCNPJ = (event) => {
        let value = event.target.value
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "");

        // REGRA: Dígitos verificadores (13 e 14) só podem ser números
        if (value.length > 12) {
            const dv = value.substring(12, 14);

            if (/[^\d]/.test(dv)) {
                // impede entrada de letras no DV
                return;
            }
        }

        const formatted = formatCNPJ(value);

        dispatch({
            type: "update",
            data: { cnpj: formatted }
        });
    };

    const formatCNPJ = (value) => {
        const cnpj = value
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
            .substring(0, 14);

        if (cnpj.length <= 2) {
            return cnpj;
        }

        if (cnpj.length <= 5) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2)}`;
        }

        if (cnpj.length <= 8) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5)}`;
        }

        if (cnpj.length <= 12) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8)}`;
        }

        return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8, 12)}-${cnpj.substring(12, 14)}`;
    };
    // Fim - CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico

    return (
        <>
            <DefaultScreenAccordion
                title={t("company")}
                isRegister
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <Grid item xs={id !== 0 ? 7 : 12} sm={id !== 0 ? 8 : 12} md={id !== 0 ? 10 : 12}>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="company" labelName="companyName" />
                                        }
                                        name="companyName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={companyName}
                                        inputProps={{ maxLength: 50 }}
                                        error={error && companyName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="company" labelName="socialReason" />
                                        }
                                        name="socialReason"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={socialReason}
                                        inputProps={{ maxLength: 150 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    {/* CBernardo - 17/06/2026 - Função antiga de CNPJ */}
                                    {/* <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="cnpj" />
                                        }
                                        name="cnpj"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={cnpj}
                                        inputProps={{ maxLength: 18 }}
                                        error={error && cnpj === ""}
                                    /> */}
                                    {/* Fim - CBernardo - 17/06/2026 - Função antiga de CNPJ */}

                                    {/* CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico */}
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="cnpj" />
                                        }
                                        name="cnpj"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChangeCNPJ}
                                        value={cnpj}
                                        inputProps={{ maxLength: 18 }}
                                        error={error && cnpj === ""}
                                    />
                                    {/* Fim - CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico */}
                                </Grid>
                                <GridInputRow>
                                </GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>
                            </GridInputRow>
                        </Grid>

                        {/* {id !== 0 ? (
                            <Grid item xs={5} sm={4} md={2}>

                                <ImageUploadCard
                                    id={id}
                                    userId={userId}
                                    uploadCallBack={() => { handleReloadImg() }}
                                    isRegister={true}
                                    iconBase64={img}
                                    endPoint={"CustomFileUploaderCompany"}
                                />
                            </Grid>
                        ) : null} */}
                        <SearchClearSaveRow
                            onClickSearch={handleSearch}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            onClickSave={handleSaveUpdate}
                        />
                        {(CompanyRows.length > 0) ? (
                            <GridInputRow>
                                <Grid item xs={12}>
                                    <DefaultDatagrid
                                        columns={columnsCompany(t)}
                                        allowPaging={true}
                                        dataSource={CompanyRows}
                                        cellSelected={(args, grid) =>
                                            handleCellClickCompany(args.data)
                                        } />
                                </Grid>
                            </GridInputRow>
                        ) : null}
                    </GridItemContainer>
                } />
        </>
    );
}